import kr from '../../kr/kr';
import HTMLClass from '../../kr/utils/HTMLClass';

export default class MenuMobile extends kr.Component {
    init() {
        this._current = null;
        this._enablePX = 993;
        this._bind();
    }

    _bind() {
        document.querySelector('button.jsHeadermenu').addEventListener('click', () => {
            HTMLClass.toggleClass(this.app.dom.$body, 'header__nav--opened');
            HTMLClass.removeClass(this.app.dom.$body, 'web__searchform--active');
        }, false);

        document.querySelector('div.web__mask').addEventListener('click', () => {
            HTMLClass.removeClass(this.app.dom.$body, 'header__nav--opened');
        }, false);

        this.on('click', '.menu-item-has-children > a', (target, event) => {
            const windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            if ( windowWidth > this._enablePX) {
                return false;
            }
            event.preventDefault();
            if (this._current == target.parentNode) {
                HTMLClass.toggleClass(this._current, 'submenu--opened');
                return;
            }
            this._current = target.parentNode;
            this._removeAllClass();
            HTMLClass.addClass(this._current, 'submenu--opened');
        });
    }
        

    _removeAllClass() {
        const els = this.$element.querySelectorAll('.menu-item-has-children');

        for (let el of els) {
            if (el == this._current) {
                continue;
            }

            HTMLClass.removeClass(el, 'submenu--opened');
        }
    }
}

kr.registerComponent('.header__menu', {
    component: MenuMobile
});